<template>
<div>
   <div v-if="loader" id="loader"></div>
  <component v-if="json.Component" :isAdvanced="json.isAdvFilter" :is="json.Component" @update="onFilterChange" :isSummeryReportExist="jsonObject.isSummeryReportExist" :showAllRec="showAllRec" @onChangeSummaryRec="onChangeSummaryRec"></component>
  <!-- <div class="row">
    <template v-for="(j,index) in json.filters">
      
     <component :is="filterComponent" @update="onFilterChange(j.fieldName, $event)" :field="j.fieldName" :key="index"></component>
    </template>

   </div> -->
  <template v-if="loaded">
    <Grid 
      ref="kGrid"
      :data-items="gridData"
      :columns="showAllRec ? summaryReportCols : columns"
      :sort="sort"
      :sortable="sortable"
      :column-menu="true"
      :resizable="true"
      :group="group"
      :groupable="groupable"
      :pageable="pageable"
      :take="take"
      :skip="skip"
      :total="totalDataCount"
      :expand-field="'expanded'"
      @sortchange="onSortChange"
      @datastatechange="onDataStateChange"
      @expandchange="onExpandChange"
      @pagechange="onPageChange"
    >
      <grid-toolbar v-if="json.searchBox">
        <div class="d-flex">
        
          <div class="ml-auto">
            <k-input
              v-model="searchText"
              placeholder="Search"
            >
            </k-input>
  
          </div>
        </div>
      </grid-toolbar>
    </Grid>
   
    
  </template>
  </div>
</template>

<script>
// import axios from "axios";
import debounce from "debounce";
// import { saveExcel } from "@progress/kendo-vue-excel-export";
import { orderBy, process } from "@progress/kendo-data-query";
//msToHMS
import moment from "moment-timezone";

import {
formatTimeOnly,
formatAMPMTimeOnly,msToHMS} from "@/utils/date-helpers";
import Api from '@/api/api'
import { workbookOptions, toDataURL } from '@progress/kendo-vue-excel-export';
import { saveAs } from '@progress/kendo-file-saver';

// import store from '@/store';
export default {
  props: {
    jsonObject: Object,
    filterComponent: String,
    baseUrl:{},
    filterObject:Object,
    isTimeformat:Boolean,
    reportServiceChannelKey:String,
    summaryReportCols:[],
    gridInfoData:{},
    summaryConfig:{}
  },

  data() {
    return {
      loaded: false,
      json: null,
      data: [],
      sort: [],
      group:[],
      columns: [],
      skip: 0,
      take: 5,
      filterObjectParams:{},
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 50, 100],
        pageSize:10
      }, 
      groupable: true,
      sortable: true,
      filterData: {},
      filteredColumn:[],
      searchText:"",
        dataBound: function() {
        for (var i = 0; i < this.columns.length; i++) {
          this.autoFitColumn(i);
        }
      },
      pageNumber:1,
      exportData:[],
      pageSize:5,
      totalDataCount:0,
      isAdvFilter:false,
      AdvFilter:null,
      showAllRec: false,
        loader:false,
      // baseURL: "http://localhost:8083/",
    };
  },

  computed: {
    dataItems() {
      if (this.serverPaging) {
        return this.data
      }
      return this.data;
    },

    total() {
      
      console.log("#data",this.data)
      if (this.serverPaging) {
        return this.data.total;
      }
      return this.data.length;
    },
    // getData(){
    //  return this.columns.map(c=>{
    //     this.data.map(d=>{

    //       if(c.dataType =="DateTime" ){
             
    //          console.log(" d[c.field]", d[c.field])
    //       }
    //     })
    //   })
    // },
     gridData() {
       console.log("this.dataItems",this.dataItems)
     let filteredData = this.dataItems.filter(
        (data) =>
          JSON.stringify(data)
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) !== -1
      );
      var data =  orderBy(filteredData, this.sort)
      // console.log("getData",this.getData)
      return  process(data, {
        skip: this.serverPaging ? undefined : this.skip,
        take: this.serverPaging ? undefined : this.take,
        group:  this.group,
      });
      
    },

    serverPaging() {
      if (this.json.pageable && this.json.pageable.server) return true;
      return false;
    },
      dataResult() {
      return this.gridData.filter(
        (data) =>
          JSON.stringify(data)
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) !== -1
      );
    },

    summaryReportCol(){
     return this.getSummeryColumns()
    }
  },

  async mounted() {
    await this.fetchJson();
    await this.fetchFilteredData()
    // await this.fetchData();
    
    this.columns = this.getColumns();
   this.summaryReportCols = this.summaryConfig ?this.getSummeryColumns():[];
    this.sort = this.getSort();
    this.group = this.json.group
 console.log('this.group',this.group)
    this.sortable = true // this.json.sortable;
    //this.pageable = this.json.pageable;


    if (this.pageable) {
      this.skip = this.pageable.skip;
      this.take = this.pageable.take;
    }
    console.log("Dataaaa8989898989",this.pageable)

    this.loaded = true;
  },

  methods: {
    async fetchJson() {
      // var response = await Api.get(this.jsonUrl);
      this.json = this.jsonObject;

      // this.json = JSON.parse(response.data.configuration);
    },
    
    fetchFilteredData(){
      this.filteredColumn=[]
     this.json.columns.map(i=>{
          this.filteredColumn.push({field:i.field})
      })
      let advanceFilter=[];

      if(this.json.isAdvFilter){

          let filterArray = this.json.AdvFilter.Filters.filter(filt =>{
            if(filt.Filters){
            advanceFilter = [...advanceFilter,...filt.Filters];
            return false;
            }

            else {
              return true;
            }
          });
          console.log("#dataconsole",filterArray)
          advanceFilter = [...filterArray,...advanceFilter]
      }
      this.filterData =   {
         columns:this.filteredColumn,
         AdvFilter:this.json.isAdvFilter?advanceFilter:undefined,
         filters: this.json.isAdvFilter ? undefined : this.json.filters,
         ChannelKey:this.reportServiceChannelKey,
         EntityName:this.json.EntityName
       }
       console.log("this.filterData",this.filterData)
        console.log("#AdvfilterData",this.filterData)

    },

    async fetchData() {
            console.log("#summary1",this.summaryConfig)

      const ds = this.showAllRec?this.summaryConfig.dataSource:this.json.dataSource;
       console.log("baseUrl",this.baseUrl)
      let body =Object.assign({}, this.filterData, { _query: undefined }); 
      body.pageNumber=this.pageNumber;
      body.pageSize=this.pageable.pageSize;
      if(this.json.isDataConverterExist){
        body.dataConverterList= this.json.dataConverterList;
      }
      if(!body.dataConverterList && this.json.isSummeryReportExist){
         body.dataConverterList= this.json.dataConverterList;
      }
      if(this.json.isAdvFilter && this.json.isSummeryReportExist ){
        body.aggregateInfoList= this.summaryConfig.aggregateInfoList;
        body.groupByColumns=this.summaryConfig.groupByColumns;
      }
      if(this.json.isSummeryReportExist ){
        body.dataConverterList= this.summaryConfig.dataConverterList;

      }
      // body.dataConverterList=(this.json.isDataConverterExist && this.json.isSummeryReportExist) ?this.json.dataConverterList:undefined;
      body.aggregateInfoList=this.json.isSummeryReportExist?this.summaryConfig.aggregateInfoList:undefined;
      body.groupByColumns=this.json.isSummeryReportExist ?this.summaryConfig.groupByColumns:undefined;
      body.retrieveGroupedData=this.json.isSummeryReportExist ?this.summaryConfig.retrieveGroupedData:undefined;
      body.sortColumns=this.json.isSummeryReportExist ?this.json.sortColumns:undefined;
      console.log("#test",this.json)

      let params = Object.assign({}, this.filterData._query, {
        skip: this.skip,
        take: this.take,
      });
   console.log("this.baseUrl",this.baseUrl,ds.url)
   this.loader = true
    await Api.request({
        method: ds.method,
        url:ds.service=="ReportService"?this.baseUrl.ReportService+ds.url:this.baseUrl.GPSCore+ds.url,
        data: body,
        params,
      }).then(response=>{
          this.data = response.data.result?response.data.result:[];
          this.totalDataCount=response.data.totalDataCount;
          this.loader=false
      }).catch(err=>{
        console.log("errrrr",err)
          this.loader=false
      })
    
     
    },

      async fetchExportData() {

      const ds = this.showAllRec?this.summaryConfig.dataSource:this.json.dataSource;
       console.log("baseUrl",this.baseUrl)
      let body =Object.assign({}, this.filterData, { _query: undefined }); 
      body.pageNumber=this.pageNumber;
      body.pageSize=this.totalDataCount;
      if(this.json.isDataConverterExist){
        body.dataConverterList= this.json.dataConverterList;
      }
      if(!body.dataConverterList && this.json.isSummeryReportExist){
         body.dataConverterList= this.json.dataConverterList;
      }
      if(this.json.isAdvFilter && this.json.isSummeryReportExist ){
        body.aggregateInfoList= this.summaryConfig.aggregateInfoList;
        body.groupByColumns=this.summaryConfig.groupByColumns;
      }
      if(this.json.isSummeryReportExist ){
        body.dataConverterList= this.summaryConfig.dataConverterList;

      }
      // body.dataConverterList=(this.json.isDataConverterExist && this.json.isSummeryReportExist) ?this.json.dataConverterList:undefined;
      body.aggregateInfoList=this.json.isSummeryReportExist?this.summaryConfig.aggregateInfoList:undefined;
      body.groupByColumns=this.json.isSummeryReportExist ?this.summaryConfig.groupByColumns:undefined;
      body.retrieveGroupedData=this.json.isSummeryReportExist ?this.summaryConfig.retrieveGroupedData:undefined;
      body.sortColumns=this.json.isSummeryReportExist ?this.json.sortColumns:undefined;
      console.log("#test",this.json)

      let params = Object.assign({}, this.filterData._query, {
        skip: this.skip,
        take: this.take,
      });
    console.log("this.baseUrl",this.baseUrl,ds.url)
    this.loader = true
    await Api.request({
        method: ds.method,
        url:ds.service=="ReportService"?this.baseUrl.ReportService+ds.url:this.baseUrl.GPSCore+ds.url,
        data: body,
        params,
      }).then(response=>{
          this.exportData = response.data.result?response.data.result:[];
          // this.totalDataCount=response.data.totalDataCount;
          this.loader=false
      }).catch(err=>{
        console.log("errrrr",err)
          this.loader=false
      })
    
     
    },
    onChangeSummaryRec(e){
      
        this.showAllRec=e.target.checked;
        this.data=[]
    },
    
    getColumns() {
      return this.sortColumns(this.json.columns, this.json.columnOrder).map(
        (col) => {
          return { field: col.field, title: col.title, width:col.width?col.width:'150px',type:col.dataType,format:col.dataType, cell:this.getTime };
        }
      );
    },
      getSummeryColumns() {
      return this.sortColumns(this.summaryConfig.columns, this.summaryConfig.columnOrder).map(
        (col) => {
          return { field: col.field, title: col.title, width:col.width?col.width:'150px',type:col.dataType,format:col.dataType, cell:this.getTime };
        }
      );
    },
    async exportExcel(){
        await this.fetchExportData()
        this.customSaveExcel({
        data: this.exportData,
        fileName:this.json.EntityName?this.json.EntityName:'report',
        columns: this.showAllRec ? this.summaryReportCols :this.columns,
      });

    },
   customSaveExcel(exportOptions) {
           // var fields = grid.dataSource.options.schema.model.fields;
 
  
   const saveFn = (dataURL) => {
        saveAs(dataURL, exportOptions.fileName, {
            forceProxy: exportOptions.forceProxy,
            proxyURL: exportOptions.proxyURL
        });
    };
    
   const options = workbookOptions(exportOptions);
          var sheet = options.sheets[0]; 
          // sheet.mergedCells = ["B1:E1"];
          //  sheet.name = "Orders"; 
             var rows = []                    
             rows.push(sheet.rows[0])

              for (var i = 0; i < exportOptions.data.length; i++){
                var rowCells = [];
                for(var j=0;j < exportOptions.columns.length;j++){
                  var cellValue
                  if(exportOptions.columns[j].type == 'DateTime')
                  {  
                      cellValue = exportOptions.data[i][exportOptions.columns[j].field];
                    if(cellValue){
                  cellValue =  cellValue.charAt(cellValue.length - 1) !== 'Z'? cellValue + 'Z':cellValue
                  rowCells.push({value:moment(cellValue).format("DD/MM/YYYY HH:mm") });
                    }
                    else
                   { rowCells.push({value:cellValue });} 
                  
                  }
                   else if(exportOptions.columns[j].type == 'millisecond' ){
                    cellValue = exportOptions.data[i][exportOptions.columns[j].field];
                    
                    rowCells.push({value:msToHMS(cellValue)});
                  }
                     else if(exportOptions.columns[j].type == 'date' ||exportOptions.columns[j].type == 'Date'){
                    cellValue = exportOptions.data[i][exportOptions.columns[j].field];
                    cellValue =  cellValue.charAt(cellValue.length - 1) !== 'Z'? cellValue + 'Z':cellValue
                    rowCells.push({value:new Date(cellValue).toLocaleDateString()});
                  }
                   else if(exportOptions.columns[j].type == 'time'){
                    cellValue = exportOptions.data[i][exportOptions.columns[j].field];
                    // console.log("cell value",cellValue)
                    if(cellValue)
                    
                   { 
                     cellValue =  cellValue.charAt(cellValue.length - 1) !== 'Z'? cellValue + 'Z':cellValue
                     rowCells.push({value:this.isTimeformat? formatTimeOnly(new Date(cellValue))
                      : formatAMPMTimeOnly(new Date(cellValue)) });}
                   else
                   { rowCells.push({value:cellValue });}
                  }
                  else{
                    cellValue = exportOptions.data[i][exportOptions.columns[j].field];
                  rowCells.push({value:cellValue});
                  }
                }
                rows.push({cells: rowCells, type: "data"});
              }
              sheet.rows = rows;      
    toDataURL(options).then(saveFn);
},
    getTime: function(h, tdElement, props) {
      const field = props.field;
       var date = props.dataItem[field];
         if (date != undefined) {

           if(props.format == 'DateTime'){
              date =  date.charAt(date.length - 1) !== 'Z'? date + 'Z':date
       let val = moment(date).format("DD/MM/YYYY HH:mm")
    
      return h(
        "td",
        {},

        val
      )
           }
       
          
        else if(props.format == 'Date'){
      
       date =  date.charAt(date.length - 1) !== 'Z'? date + 'Z':date
       let val = new Date(date).toLocaleDateString()
    
      return h(
        "td",
        {},

        val
      );
      }
       else if(props.format == 'millisecond'){
      return h(
        "td",
        {},

        msToHMS(date)
      );
      }
      else{
       let val = date
    
      return h(
        "td",
        {},

        val
      ); 
      }
         }
            else {
        return h("td", {}, "");
      }

    },
    getSort() {
      return this.json.columns
        .filter((x) => x.sort)
        .map((col) => {
          return { field: col.field, dir: col.sort };
        });
    },

    getGroup() {
      return this.json.columns
        .filter((x) => x.group)
        .map((col) => {
          return { field: col.field };
        });
    },

    sortColumns(columns, columnOrder) {
      return columns.sort((a, b) => {
        if (columnOrder.indexOf(a.field) == -1) return 1; //move newly added item to last
        return columnOrder.indexOf(a.field) > columnOrder.indexOf(b.field)
          ? 1
          : -1;
      });
    },

    onSortChange(e) {
      this.sort = e.sort;
    },

    onDataStateChange(event) {
      this.group = event.data.group;
    },

    onExpandChange(event) {
      event.dataItem[event.target.$props.expandField] = event.value;
    },

    onFilterChange: debounce(function (data) {
      this.filterData =this.json.dataSource.method=='GET'? data:this.assignFilterObject(data) || {};
      console.log("filterData####",  this.filterData)
      this.fetchData();
     
    }, 500),

    async onPageChange(event) {
      console.log("#kendo",this.$refs)
      //var grid = this.$refs.kGrid.kendoWidget();

      this.skip = event.page.skip;
      this.take = event.page.take;
      this.pageNumber = event.page.skip/event.page.take+1
      //this.pageSize= grid.dataSource.pageSize(),
      this.pageable.pageSize=event.page.take;
      

      console.log("#pagesize",this.pageNumber);
    
        await this.fetchData();
        

    },
    assignFilterObject(data){
    let advanceFilter=[];
    // let isAdvanced = false
//    let Rtodata ={
//      datatype: "String",
// fieldId: "RTONumber",
// fieldName: "RTONumber",
// operator: "eq",
// value: "",
  //  }
      if(this.json.isAdvFilter){
        let tempData =[]
            let filterArray = this.json.AdvFilter.Filters.filter(filt =>{
                if(filt.Filters){

                filt.Filters.map((i,index)=>{

                
                  for (const key in data) {

                        if(Array.isArray( data[key])) {
                          // isAdvanced = true
                          
                          let Rtodata 
                          if(i.fieldId == key)
                          {
                              Rtodata = filt.Filters[index]
                              // filt.Filters.splice(index , 1)
                                  
                          tempData=  data[key].map((i)=>{ 
                              Rtodata.value = i
                              return  {...Rtodata}
                          })
                        //  filt.Filters = tempData
                          }
                         console.log('tempData',tempData)
                      
                              //  filt.Filters = tempData
                         }
                         else{
                          //  filt.Filters.push(i)
                         }
                    }
                 }) 
                    advanceFilter = [...advanceFilter,...filt.Filters];
                      return false;
                }
                else {
                  return true;
                }
          });
        advanceFilter = [...filterArray,...advanceFilter]
        this.json.AdvFilter.Filters.map(f=>{
          if(f.Filters){
               f.Filters.forEach((e) => {
            Object.keys(data)
          .forEach(function eachKey(key) {
            if(e.fieldId == key ){
               if(!Array.isArray( data[key])){
                e.value = data[key]
               }
              else{
                f.Filters = tempData
              }
              
            }
            return  
          });
        });
          }
          else{
            Object.keys(data)
          .forEach(function eachKey(key) {
            if(f.fieldId == key ){
                f.value = data[key]
              //  }
              
              
            }
            return  
          });
        // });
          }
        })
     
     
        console.log("ghghghghgh",this.json.AdvFilter)
       } 
       if(!this.json.isAdvFilter)
       this.json.filters.forEach((e) => {
        //  let t = this
          Object.keys(data)
            .forEach(function eachKey(key) {
              // console.log(key) 
              if(e.fieldId == key){
                e.value = data[key]
                
              }
              // if(key == 'RTONumber' && data[key] ==''){
              //   t.group = [ { field: 'RTONumber' } ]
              // }
              // else{
              //   t.group = []
              // }
             return  
        });
        return
        //  if(element.fieldName == val){
        //    element.value = data.name
        //  }
       });
       
       let filterObject= {
         columns:this.filteredColumn,
         filters: this.json.isAdvFilter ? undefined : this.json.filters,
         AdvFilter:this.json.isAdvFilter ? this.json.AdvFilter: undefined,
         ChannelKey:this.reportServiceChannelKey,
         EntityName:this.json.EntityName,
        //  isAdvFilter:this.json.isAdvFilter?true:false,
       }
       this.skip = 1
       this.pageNumber = 1
       this.filterObjectParams = filterObject
      return filterObject
    }

  },
};
</script>

<style>
</style>